import 'whatwg-fetch';
import {notifyFetchErrors} from '../../../../utilities/fetch';
import {isTestMode} from '../components/workflow/helpers/test_mode';
import getCSRFToken from '../../../../utilities/security/token-fetcher';

const BASE_URI = '/services_marketplace/job_requests';
const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-Token': getCSRFToken(),
};

export function submitBrief(brief) {
  const options = {
    headers,
    credentials: 'same-origin',
    method: 'POST',
    body: JSON.stringify(brief),
  };

  const URI = isTestMode() ? `${BASE_URI}?test_mode=true` : BASE_URI;

  return fetch(URI, options)
    .then(
      notifyFetchErrors('ServicesMarketplace::BriefSubmitRejected', {brief})
    )
    .then(response => response.json());
}
